import { render, staticRenderFns } from "./GameNew.vue?vue&type=template&id=35138805&scoped=true"
import script from "./GameNew.vue?vue&type=script&lang=js"
export * from "./GameNew.vue?vue&type=script&lang=js"
import style0 from "./GameNew.vue?vue&type=style&index=0&id=35138805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35138805",
  null
  
)

export default component.exports